// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"c978258a","544":"4e347b01"}[chunkId] + ".chunk.js";
};